/** Approved hero copy. Keep the video disabled until the original asset is supplied. */
export const heroVideo = {
  // TODO: Add the original Ibtkary video URL or local public path, provide a poster,
  // then set enabled: true and temporary: false after reviewing desktop/mobile playback.
  enabled: false,
  src: "",
  poster: undefined as string | undefined,
  temporary: true,
};

export const heroCopy = {
  ar: {
    main: "الإبتكار عندنا بديهي", end: "مش اختيار",
    service: "من الفكرة لأول عميل.",
    description: "نفهم فكرتك، نصمّم تجربتها، ونحوّلها لتطبيق أو موقع أو منصة رقمية جاهزة لأول خطوة مع عملائك.",
    start: "ابدأ معنا", work: "أعمالنا", sample: "مقطع تجريبي مؤقت", video: "فيديو ابتكاري",
    play: "تشغيل الفيديو", pause: "إيقاف الفيديو", mute: "كتم الصوت", unmute: "تفعيل الصوت",
    expand: "عرض الفيديو كاملًا", close: "إغلاق عرض الفيديو", fullscreen: "ملء الشاشة", seek: "موضع الفيديو",
    loading: "تحميل الفيديو…", failed: "تعذّر تحميل الفيديو. حاول مرة أخرى.", retry: "إعادة المحاولة",
    blocked: "تعذّر بدء التشغيل. اضغط لتجربته مرة أخرى.",
  },
  en: {
    main: "Innovation is second nature to us", end: "not a choice.",
    service: "From idea to your first customer.",
    description: "We understand your idea, shape the experience, and build an app, website, or digital platform ready to welcome your first customers.",
    start: "Get Started", work: "Our Work", sample: "Temporary sample video", video: "Ibtkary video",
    play: "Play video", pause: "Pause video", mute: "Mute", unmute: "Unmute",
    expand: "View the full video", close: "Close video", fullscreen: "Fullscreen", seek: "Video position",
    loading: "Loading video…", failed: "The video could not load. Please try again.", retry: "Try again",
    blocked: "Playback could not start. Press play to try again.",
  },
};
